import React, { useEffect, useState } from 'react';
import { HashRouter, Route, Routes } from "react-router-dom"; 

import Header from "./Layout/HeaderBody";
import Intro from "./Intro/IntroBody";
import Hyeto from "./Hyeto/HyetoBody"
import NotFound from "./Layout/NotFoundBody"; 

function Router() {

  const [hyeto, setHyeto] = useState();

  useEffect(() => {
    const pathName = window.location.hash.replace(/[\/#]/g, '').split('?');
    setHyeto((pathName[0]=== 'Hyeto') ? true : false);
  }, []);

  return (<>
    { hyeto === false && <Header /> }
    <HashRouter>
    <main id={ hyeto === true ? '_hyeto' : '_main' }> 
      <Routes>
          <Route path="/" element={ <Intro /> } />
          <Route path="/Hyeto" element={ <Hyeto /> } />
          <Route path="/*" element={ <NotFound /> } />
      </Routes>
    </main>
    </HashRouter>
    </>
  );
}

export default Router;
